import React, { useCallback, useEffect } from 'react';
import { getShortUserName, setClass, TCalendarInervalFilter, useViewModel } from '@utils';
import { CalendarViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import { Button } from '../../button';
import { ButtonGroup } from '../../buttonGroup';
import { Cross, SmallArrowLeft, SmallArrowRight } from '../../svgs';
import { MeetingViewModel } from '../views';
import { FilterViewModel } from '../../filter';
import '../../../styles/components/calendar/calendarFilters.scss';

export const CalendarFilters = observer(() => {

  const calendarViewModel = useViewModel(CalendarViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);
  const filterViewModel = useViewModel(FilterViewModel);

  const handleFilterIntervalSelectChange = (mode: TCalendarInervalFilter) => {
    calendarViewModel.clearCalendarData();
    calendarViewModel.setSelectedFilter(mode);
    calendarViewModel.setFirstDayOfIntervalAsCurrent();
  };

  const moveToPrevCalendarData = () =>
    calendarViewModel.movingBeetweenCalendarData('prev', calendarViewModel.filterInterval);

  const moveToNextCalendarData = () =>
    calendarViewModel.movingBeetweenCalendarData('next', calendarViewModel.filterInterval);

  const resetUser = useCallback(() => filterViewModel.setSelectEmployee(), []);
  let isCurrentUser = calendarViewModel.selectedUser === null;

  useEffect(() => {isCurrentUser = calendarViewModel.selectedUser === null}, [calendarViewModel.selectedUser]);

  const addNewMeeting = () => calendarViewModel.updateToday()
    .then(() => meetingViewModel.openAddNewMeetingForm(calendarViewModel.today));

  return (
    <div className={setClass('filters-with-cross', !isCurrentUser && 'with-padding-for-cross')}>
      <div className={setClass("filters", !isCurrentUser && "selected-user-block-margin")}>
        <ButtonGroup
          selectedId={calendarViewModel.filterInterval}
          buttons={[
            {
              title: 'День',
              id: 'day',
              onClick: () => handleFilterIntervalSelectChange('day')
            }, {
              title: 'Неделя',
              id: 'week',
              onClick: () => handleFilterIntervalSelectChange('week')
            }, {
              title: 'Месяц',
              id: 'month',
              onClick: () => handleFilterIntervalSelectChange('month')
            },
          ]}
        />
        <div className="settings-calendar">

          <Button title='Сегодня' className="soft" onClick={calendarViewModel.goToToday} />

          <div className="move-in-calendar">

            <Button
              icon={<SmallArrowLeft />}
              className="soft move-in-calendar-button"
              onClick={moveToPrevCalendarData}
            />

            <div className="current-date">
              {calendarViewModel.currentDateTitle}
            </div>

            <Button
              icon={<SmallArrowRight />}
              className="soft move-in-calendar-button"
              onClick={moveToNextCalendarData}
            />
          </div>
        </div>
        {isCurrentUser
          ? (
            <Button
              title='Добавить встречу'
              className="medium-long"
              onClick={addNewMeeting}
            />
          )
          : (
            <div className='selected-user-block'>
              <img src={calendarViewModel.selectedUser.img} className="selected-user-avatar" />
              <div className='selected-user-labels'>
                <p className='selected-user-name'>{getShortUserName(calendarViewModel.selectedUser.fullName)}</p>
                <p className='selected-user-position'>{calendarViewModel.selectedUser.position}</p>
              </div>
            </div>
          )
        }

      </div>
      {!isCurrentUser && (
        <Cross
          width={18}
          height={18}
          divClassName='close-employee-cross'
          onClick={resetUser}
        />
      )}
    </div>
  );
});
